import React from "react";
import { FleetrifyModal } from "../../../Modal/modal";
import { FleetrifyButton } from "../../../Button/customButton";

export type BranchBulkUploadRow = {
  BranchName: string;
  ManagerName: string;
  email: string;
  phoneNumber: string;
  location: string;
  address: string;

};

interface BranchPreviewModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (open: boolean) => void;
  isLoading: boolean;
  onSubmit: () => void;
  disabled?: boolean;
  rows: BranchBulkUploadRow[];
}

const BranchPreviewModal: React.FC<BranchPreviewModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  isLoading,
  onSubmit,
  disabled,
  rows,
}) => {
  return (
    <FleetrifyModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      title="Preview Branch Upload"
      className="max-w-4xl h-fit"
    >
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 rounded-lg">
          <thead className="bg-gray-100 text-sm text-left text-gray-600">
            <tr>
              <th className="p-3 border">Branch Name</th>
              <th className="p-3 border">Manger Name</th>
              <th className="p-3 border">Branch Email</th>
              <th className="p-3 border">Phone Number</th>
              <th className="p-3 border">Location</th>
              <th className="p-3 border">Address</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {rows.length > 0 ? (
              rows.map((row, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="p-2 border">{row.BranchName}</td>
                  <td className="p-2 border">{row.ManagerName}</td>
                  <td className="p-2 border">{row.email}</td>
                  <td className="p-2 border">{row.phoneNumber}</td>
                  <td className="p-2 border">{row.location}</td>
                  <td className="p-2 border">{row.address}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center p-4 text-gray-400">
                  No staff data to preview
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* actions */}
      <div className="flex justify-end gap-3 mt-6 p-6 ">
        <FleetrifyButton
          type="button"
          className="border bg-transparent border-[#143887] text-[#143887] hover:bg-gray-100"
          onClick={() => setIsModalOpen(false)}
        >
          Cancel
        </FleetrifyButton>
        <FleetrifyButton
          loading={isLoading}
          disabled={disabled || rows.length === 0}
          onClick={onSubmit}
        >
          Submit Upload
        </FleetrifyButton>
      </div>
    </FleetrifyModal>
  );
};

export default BranchPreviewModal;
